import maxBy from 'lodash/maxBy'
import minBy from 'lodash/minBy'

export const getSeries = <T extends { shrimpAge: number }>(
  categories: Record<string, string>,
  data: T[] | undefined
) => {
  const result: Record<string, any[]> = Object.fromEntries(
    Object.values(categories).map((el) => [el, []])
  )

  if (!data) return result

  data.forEach((el) => {
    Object.values(categories).forEach((type) => {
      const val = el[type as keyof T]
      if (val) {
        result[type].push([el.shrimpAge, val])
      }
    })
  })

  return result
}

export const getMinMaxValueFromSeries = (sources: any[]) => {
  return {
    min: minBy(sources, (item) => item[1])?.[1],
    max: maxBy(sources, (item) => item[1])?.[1],
  }
}
